import React, { useState } from 'react';
import C from './ToggleChip.css';
import Chip from '@mui/material/Chip';
import { SxProps, Theme } from '@mui/material';

export default function ToggleChip(p: {
  label: React.ReactNode;
  isSelected?: boolean;
  isSelectedDefault?: boolean;
  onSelect?: () => void;
  onDeselect?: () => void;
  sx?: SxProps<Theme>;
}) {
  return (
    <Chip
      label={p.label}
      size='small'
      sx={p.sx}
      className={p.isSelected ? C.selected : C.deselected}
      onClick={() => {
        if (!p.isSelected) {
          p.onSelect?.();
        } else {
          p.onDeselect?.();
        }
      }}
    />
  );
}
